import React, { useState } from "react";
import "./LegalDocModal.css";
import { Button } from "antd";
import RichTextEditor from "../richText/RichTextEditor";
import { GreenNotify, RedNotify } from "../../helper/helper";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

// Single editor modal for the three legal docs in `legal_documents`.
// `id` selects which field of the doc to edit (and which collection doc):
//   "0" -> aboutUs, "1" -> policy, "2" -> terms.
const FIELD_BY_ID = { 0: "aboutUs", 1: "policy", 2: "terms" };

const LegalDocModal = ({ setShowModal, item, id, refreshData }) => {
  const keyName = FIELD_BY_ID[id];
  const [description, setDescription] = useState(item?.[keyName] || "");
  const [isLoading, setIsLoading] = useState(false);

  const updateLegalDocument = async () => {
    try {
      setIsLoading(true);
      const querySnapshot = await getDocs(collection(db, "legal_documents"));
      if (querySnapshot.empty) {
        throw new Error("No legal documents found");
      }
      if (!keyName) {
        throw new Error("Unknown legal document");
      }

      const docRef = doc(db, "legal_documents", querySnapshot.docs[id].id);
      await updateDoc(docRef, {
        [keyName]: description,
        updatedAt: new Date(),
      });

      GreenNotify(`${keyName} document updated successfully!`);
      refreshData();
      setShowModal(false);
    } catch (error) {
      console.error("Error updating legal document:", error);
      RedNotify(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="add-product-modal-main-container">
      <div className="add-product-modal-container">
        <div style={{ marginTop: "5rem" }}></div>
        <div>
          <h3>Content</h3>
          <RichTextEditor value={description} onChange={setDescription} />
        </div>

        <div className="modal-btn-container"></div>
        <div style={{ marginBottom: "3rem", marginTop: "1.5rem" }}>
          <Button onClick={() => setShowModal(false)} type="default" danger>
            Cancel
          </Button>
          <Button
            onClick={updateLegalDocument}
            style={{ marginLeft: "2rem" }}
            type="primary"
            loading={isLoading}
          >
            Update
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LegalDocModal;
